import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui-hud";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <Card className="max-w-lg w-full text-center">
        <XCircle className="h-12 w-12 text-slate-400 mx-auto mb-4" />
        <div className="overline text-slate-400 mb-2">CHECKOUT CANCELLED</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mb-2">No charge, no harm.</h1>
        <p className="text-sm text-slate-400 mb-6">You closed the Stripe checkout before completing payment.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/membership" data-testid="btn-cancel-retry" className="btn-hud btn-hud-solid">BACK TO MEMBERSHIP <ArrowRight className="h-3.5 w-3.5" /></Link>
          <Link to="/dashboard" data-testid="btn-cancel-dashboard" className="btn-hud">COCKPIT</Link>
        </div>
      </Card>
    </div>
  );
}
